<template>
  <div :class="classObject">
    <InputfieldLabel
      :class="labelClass"
      :text="label"
      :for="fieldId"
    />
    <InputfieldDescription
      :text="description"
    >
      <slot name="description" />
    </InputfieldDescription>
    <div class="field__content">
      <input
        ref="input"
        class="field__input field__input--text"
        v-bind="[$attrs, $listeners]"
        :type="type"
        :id="fieldId"
        :name="name"
        :value="value"
        :disabled="disabled"
        :required="required"
        @input.prevent="onInput"
      >
      <span
        class="inputClearButton"
        v-if="showClearButton && value"
        @click="clearInput($event.target)"
      >
        <span class="inputClearButton__line inputClearButton__line--first" />
        <span class="inputClearButton__line inputClearButton__line--second" />
      </span>
      <span
        v-if="unit"
        class="field__unit"
      >
        {{ unit }}
      </span>
    </div>
    <InputfieldErrors :items="parsedErrors" />
    <InputfieldNotes :text="notes" />
  </div>
</template>

<script>

import InputfieldMixin from '@/components/forms/InputfieldMixin'
import InputfieldLabel from '@/components/forms/InputfieldLabel'
import InputfieldDescription from '@/components/forms/InputfieldDescription'
import InputfieldNotes from '@/components/forms/InputfieldNotes'

export default {
  name: 'InputfieldText',
  inheritAttrs: false,
  mixins: [
    InputfieldMixin,
  ],
  components: {
    InputfieldLabel,
    InputfieldDescription,
    InputfieldNotes,
  },
  data () {
    return {
      throttleTimeout: '',
    }
  },
  props: {
    type: {
      type: String,
      required: false,
      default () {
        return 'text'
      },
    },
    labelClass: {
      type: String,
      required: false,
      default () {
        return ''
      },
    },
    unit: {
      type: String,
      required: false,
      default () {
        return ''
      },
    },
    throttle: {
      type: Number,
      required: false,
      default () {
        return 0
      },
    },
    showClearButton: {
      type: Boolean,
      required: false,
      default () {
        return false
      },
    },
  },
  methods: {
    onInput (e) {
      this.clearErrors()
      this.$emit('input', e.target.value)
    },
    clearInput () {
      this.$emit('input', '')
    },
    focus () {
      this.$refs.input.focus()
    },
    disableMouseWheel () {
      this.$refs.input.blur()
    },
    disableArrowKeys (e) {
      if (['ArrowUp', 'ArrowDown'].includes(e.key)) e.preventDefault()
    },
  },
  mounted () {
    if (this.type == 'number') {
      this.$refs.input.addEventListener('mousewheel', this.disableMouseWheel, {
        passive: true,
      })
      this.$refs.input.addEventListener('keydown', this.disableArrowKeys)
    }
  },
  beforeDestroy () {
    if (this.type == 'number') {
      this.$refs.input.removeEventListener('mousewheel', this.disableMouseWheel)
      this.$refs.input.removeEventListener('keydown', this.disableArrowKeys)
    }
  },
}

</script>

<style lang="scss" scoped>

  $clearButtonSize: 1em;

  .inputClearButton {
    position: absolute;
    right: 0;
    top: 50%;
    display: block;
    width: $clearButtonSize;
    height: $clearButtonSize;
    background: #fff;
    border-radius: $clearButtonSize;
    transform: translateY(-50%) translateX(-50%);

    &__line {
      position: absolute;
      left: 50%;
      top: 50%;
      width: 70%;
      height: $clearButtonSize * 0.16;
      background: #000;
      transform: translateY(-50%);

      &--first {
        transform: translateY(-50%) translateX(-50%) rotate(45deg);
      }

      &--second {
        transform: translateY(-50%) translateX(-50%) rotate(-45deg);
      }
    }
  }

</style>
